import { gql } from '@apollo/client';

export const UPDATE_ASSIGNMENT_PAGENUMBER = gql`
  mutation updateAssignmentPageNumber(
    $assignmentId: UUID!
    $pageNumber: UnsignedInt!
  ) {
    updateAssignment(
      data: { pageNumber: $pageNumber }
      where: { id: $assignmentId }
    ) {
      id
    }
  }
`;
